//
// README - Beta Component
//
// This component is marked "beta" and will go through some iterations
// before landing at a final solution. Please reach out to the Cadence team
// if you intend to use this in the meantime and we'll help you out!
//

import React from 'react';
import { RCSkeleton, RCEyebrow } from '../';

interface LinkElementProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  className?: string;
  children?: React.ReactNode;
}

interface RCProductCardProps {
  title: string;
  eyebrow: string;
  details: string | JSX.Element;
  imageUrl: string;

  /** The link element (e.g. CoreLink)
   * Example: `linkElement={(children) => (<CoreLink to="/whatever/url/">{children}</CoreLink>)}`
  */
  linkElement?: (children: React.ReactNode) => React.ReactElement<LinkElementProps>;
}

export function RCProductCard({
  title,
  eyebrow,
  details,
  imageUrl,
  linkElement,
}: RCProductCardProps) {
  function PassedLink({ children, className, ...passthroughProps }) {
    if (!linkElement) {
      return <>{children}</>;
    }
    return React.cloneElement(
      linkElement(children),
      {
        className: className,
        ...passthroughProps,
      },
    );
  }

  return (
    <div className="rc-product-card">
      <PassedLink className="rc-product-card__link">
        <div className="rc-product-card__image-wrapper">
          <img
            className="rc-product-card__image"
            src={imageUrl}
            alt=""
          />
        </div>
        <div className="rc-product-card__content">
          <div className="rc-product-card__eyebrow">
            <RCEyebrow text={eyebrow} />
          </div>
          <div
            className="rc-product-card__title"
            title={title}
          >
            {title}
          </div>
          <div className="rc-product-card__details">
            {details}
          </div>
        </div>
      </PassedLink>
    </div>
  );
}

function Skeleton() {
  return (
    <div className="rc-product-card">
      <div className="rc-product-card__image-wrapper">
        <RCSkeleton width="100%" height="100%" />
      </div>
      <div className="rc-product-card__content">
        <div className="rc-product-card__title">
          <RCSkeleton width="75%" />
        </div>
        <div className="rc-product-card__details">
          <RCSkeleton width="0" />
        </div>
      </div>
    </div>
  );
}

RCProductCard.Skeleton = Skeleton;
